import { render, staticRenderFns } from "./LinkInvalido.vue?vue&type=template&id=39851229&"
import script from "./LinkInvalido.vue?vue&type=script&lang=js&"
export * from "./LinkInvalido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports